import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["use", "size", "children"];
import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import styled from 'styled-components';
import { EXTRA_SMALL, SMALL, MEDIUM } from '../constants/sizes';
import themePropType from '../utils/themePropType';
import { interactionPropTypes } from '../utils/types';
import * as ButtonUses from './constants/ButtonUses';
import mergeThemeStyles from '../theme/mergeThemeStyles';
import { buttonTheme } from './theme/buttonTheme';
import { jsx as _jsx } from "react/jsx-runtime";
const AbstractVizExButton = styled.button.withConfig({
  displayName: "VizExButton__AbstractVizExButton",
  componentId: "az6h8l-0"
})(["", ""], ({
  theme
}) => mergeThemeStyles({
  component: 'Button',
  defaultStyles: buttonTheme,
  theme
}));
const NoSelect = styled.div.withConfig({
  displayName: "VizExButton__NoSelect",
  componentId: "az6h8l-1"
})(["user-select:none;"]);
const VizExButton = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      use = ButtonUses.SECONDARY,
      size = MEDIUM,
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(AbstractVizExButton, Object.assign({}, Object.assign({
    use,
    size
  }, rest), {
    ref: ref,
    children: /*#__PURE__*/_jsx(NoSelect, {
      children: children
    })
  }));
});
VizExButton.displayName = 'VizExButton';
VizExButton.propTypes = Object.assign({
  children: PropTypes.node,
  onClick: PropTypes.func,
  size: PropTypes.oneOf([EXTRA_SMALL, SMALL, MEDIUM]),
  theme: themePropType,
  use: PropTypes.oneOf(Object.values(ButtonUses))
}, interactionPropTypes);
export default VizExButton;